import { Card, CardActionArea, CardContent, Link, Paper } from '@mui/material';
import { PropsWithChildren, memo } from 'react';

type Props = PropsWithChildren<{
  borderLeftColor: string;
  backgroundColor?: string;
  href?: string;
  className?: string;
  tabIndex?: 0 | -1;
  grow?: boolean;
  ariaLabel?: string;
}>;

// ItemCard is for non-selectable instances
export const ItemCard = memo(({ children, borderLeftColor, backgroundColor = 'white', href, ariaLabel, className = '', tabIndex, grow = false }: Props) => {
  return (
    <Card
      className={`item-card ${className}`}
      sx={{
        borderRadius: 0,
        backgroundColor,
        borderLeft: `4px solid`,
        borderLeftColor,
        borderTop: `1px solid rgba(0, 0, 0, 0.12)`,
        width: 1,
        height: grow ? 1 : 'auto',
        '& a:hover': { textDecoration: 'none' },
      }}
    >
      <CardActionArea
        LinkComponent={href ? Link : undefined}
        tabIndex={tabIndex}
        href={href || ''}
        aria-label={ariaLabel}
        sx={grow ? { height: 1, display: 'flex', alignItems: 'center', justifyContent: 'start' } : {}}
      >
        <CardContent sx={{ py: 1 }}>{children}</CardContent>
      </CardActionArea>
    </Card>
  );
});

// MultiSelectItemCard is for issues and instances that allow multi selecion for export
export const MultiSelectItemCard = memo(({ children, borderLeftColor, backgroundColor = 'white', className = '' }: Props) => {
  return (
    <Paper
      className={`item-card ${className}`}
      sx={{
        borderRadius: 0,
        backgroundColor,
        borderLeft: `4px solid`,
        borderLeftColor,
        borderTop: `1px solid rgba(0, 0, 0, 0.12)`,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        py: 1,
        px: 1.625,
      }}
    >
      {children}
    </Paper>
  );
});
